import { render } from "./UserOptionsModal.vue?vue&type=template&id=1ce84202&scoped=true&ts=true"
import script from "./UserOptionsModal.ts?vue&type=script&lang=ts"
export * from "./UserOptionsModal.ts?vue&type=script&lang=ts"

import "./UserOptionsModal.scss?vue&type=style&index=0&id=1ce84202&lang=scss&scoped=true"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ce84202"]])

export default __exports__